import { graphql, useStaticQuery, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import sprite from '../../../static/sprite.svg';
import Button from '../Button/Button';
import './Footer.scss';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      file(relativePath: { eq: "footer.json" }) {
        childTextContentJson {
          copyright
          address
        }
      }
    }
  `);

  return (
    <footer className="footer">
      <div className="footer__left-col">
        <a href="mailto:smile@letthemshineusa.org" className="footer__btn">
          Contact Us
          <span className="footer__arrow-box">
            <svg className="footer__arrow">
              <use href={`${sprite}#right-arrow`} />
            </svg>
          </span>
        </a>

        <div className="footer__address-and-links">
          <p className="footer__address">
            {data.file.childTextContentJson.address}
          </p>
          <ul className="footer__list">
            <li className="footer__list-item">
              <a
                href="https://apps.letthemshineusa.org/privacy-policy"
                className="footer__link"
              >
                Privacy Policy
              </a>
            </li>
            <li className="footer__list-item">
              <a
                href="https://apps.letthemshineusa.org/terms-conditions"
                className="footer__link"
              >
                Terms and Conditions
              </a>
            </li>
            <li className="footer__list-item">
              <a
                href="https://apps.letthemshineusa.org/refund-policy"
                className="footer__link"
              >
                Refund Policy
              </a>
            </li>
          </ul>
        </div>

        {/* <div className="footer__social-links">
          <a
            className="footer__icon-box"
            href="https://www.facebook.com/StraumannUS/"
            target="_blank"
          >
            <svg className="footer__icon">
              <use href={`${sprite}#facebook`} />
            </svg>
          </a>
          <a
            className="footer__icon-box"
            href="https://twitter.com/straumannus?lang=en"
            target="_blank"
          >
            <svg className="footer__icon">
              <use href={`${sprite}#twitter`} />
            </svg>
          </a>
          <a
            className="footer__icon-box"
            href="https://www.youtube.com/channel/UCehQCA5FV97jUWhcqmz8rVg"
            target="_blank"
          >
            <svg className="footer__icon">
              <use href={`${sprite}#youtube`} />
            </svg>
          </a>
          <a className="footer__icon-box">
            <svg className="footer__icon">
              <use href={`${sprite}#instagram`} />
            </svg>
          </a>
          <a className="footer__icon-box">
            <svg className="footer__icon">
              <use href={`${sprite}#linkedin`} />
            </svg>
          </a>
        </div> */}

        <a href="mailto:smile@letthemshineusa.org" className="footer__mail">
          Form 990 Available on request
        </a>

        <p className="footer__copyright">
          {data.file.childTextContentJson.copyright}
        </p>
      </div>
      <div className="footer__right-col">
        <div className="footer__logo-box">
          <Link to="/">
            <svg className="footer__logo">
              <use href={`${sprite}#logo`} />
            </svg>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
